import React, {useState, useRef, useEffect, useMemo} from 'react';
import './ExpirationDateField.css';
import { useField } from 'formik';

const BASE_CLASSNAMES = (error, touched) => ({
    wrapper: 'field__wrapper',
    invalid: 'field__wrapper',
    label: error && touched ? 'field__label --error' : 'field__label',
    required: error && touched ? 'field__required --error' : 'field__required',
    error: 'field__error',
    input: error && touched ? 'field__container --error' : 'field__container',
    rightSection: 'field__rightSection',
    item: 'field__item',
});

function validateRequired(value) {
    let error;
    if (!value) {
        error = 'Este campo es obligatorio';
    }
    return error;
}

const ExpirationDateField = (props) => {
    const yearInputRef = useRef(null);

    const { label, name, isRequired } = props;
    const [field, meta, helpers] = useField({
        name,
        validate: isRequired ? validateRequired : null});
    const baseClassNames = BASE_CLASSNAMES(meta.error, meta.touched);
    const [value, setValue] = useState(() => {
        if (field.value) {
            const [month, year] = field.value.split('/');
            return { month, year: year.slice(-2) };
        }
        return { month: '', year: '' };
    });
    const { setValue: setFieldValue } = helpers;
    const [showSeparator, setShowSeparator] = useState(true);
    const hasError = useMemo(() => meta.error && meta.touched, [meta.error, meta.touched]);
    const errorMessageText = hasError ? meta.error : null;

    useEffect(() => {
        if ((value.month.length === 2 || value.month === '1') && value.year.length === 2) {
            const fullYear = `20${value.year}`;
            setFieldValue(`${value.month.length === 2 ? value.month : '0' + value.month}/${fullYear}`);
        } else if (value.month === '' || value.year === '') {
            setFieldValue('');
        }
    }, [value.month, value.year]);

    const resetField = (fieldOption) => {
        switch (fieldOption) {
            case 'month':
                setValue(prev => ({ ...prev, month: '' }));
                break;
            case 'year':
                setValue(prev => ({ ...prev, year: '' }));
                break;
            case 'both':
                setValue({ month: '', year: '' });
                break;
            default:
                break;
        }
        setFieldValue('');
    };

    const handleMonthChange = (e) => {
        let newValue = e.target.value;

        // Validación: no permitir "0" o "00"
        if (newValue === '00') {
            resetField('month');
            return;
        }

        // Validación: agregar "0" a los valores de 2 a 9
        if (newValue.length === 1 && newValue !== '1' && newValue !== '0') {
            newValue = '0' + newValue;
        }

        // Validación: solo permitir valores entre 01 y 12
        if (parseInt(newValue, 10) > 12) {
            resetField('month');
            setShowSeparator(false);
            return;
        }

        if (newValue.length <= 2) {
            setValue(prev => ({ ...prev, month: newValue }));
            setShowSeparator(true);
            if (newValue.length === 2) {
                yearInputRef.current.focus();
            }
        }
    };

    const handleYearChange = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= 2) {
            setValue(prev => ({ ...prev, year: newValue }));
        }
    };

    return (
        <div className={`${baseClassNames.wrapper}`}>
            <label className={baseClassNames.label}>
                {label}
            </label>
            <div className={`${baseClassNames.input} CCF__inputContainer`}>
                <input
                    className="CCF__field CCF__fieldText"
                    type="text"
                    value={value.month}
                    onChange={handleMonthChange}
                    maxLength="2"
                    pattern="\d{1,2}"
                    placeholder="MM"
                    autoComplete="off"
                />
                {showSeparator && <span className="CCF__fieldText">/</span>}
                <input
                    className="CCF__field CCF__fieldText"
                    type="text"
                    value={value.year}
                    onChange={handleYearChange}
                    maxLength="2"
                    pattern="\d{2}"
                    placeholder="YY"
                    ref={yearInputRef}
                    autoComplete="off"
                />
            </div>
            {errorMessageText && <p className={baseClassNames.error}>{errorMessageText}</p>}
        </div>
    );
};

export default ExpirationDateField;
